export class HistErrorCode {
  public static readonly DiagRepeat = 'MSG_HistErrorCode1';
  public static readonly OrderRequiredField = 'MSG_HistErrorCode2';
  public static readonly OrderRepeat = 'MSG_HistErrorCode3';
  public static readonly OrderFilled = 'MSG_HistErrorCode4';
}
